import { useQuery } from 'react-query';

import * as storageService from 'services/storage.service';

import userService from 'resources/user/user.service';

const getUserById = async (id) => {
  if (!id) {
    return null;
  }

  const user = await userService.getUserById(id);

  if (!user) {
    return null;
  }

  if (user.avatar_url) {
    const avatarUrl = await storageService.getAvatarUrl(user.avatar_url);

    user.avatar_url = avatarUrl;
  }

  return user;
};

export default function useUserById(clientId, queryOptions) {
  return useQuery(
    ['users.userById', clientId],
    () => getUserById(clientId),
    queryOptions,
  );
}
